var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFinance = function SvgFinance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4546 5.21663V4.71663H17.9546H12.1522H11.6522V5.21663V7.55312C11.6522 7.65966 11.6563 7.77692 11.6598 7.87523C11.6615 7.92396 11.6631 7.96804 11.6639 8.00386C11.6657 8.0835 11.6647 8.14079 11.6617 8.18255C11.316 8.18073 11.0356 7.8993 11.0356 7.55312V5.85897C11.0356 4.88934 11.8249 4.1001 12.7945 4.1001H17.3123C18.2819 4.1001 19.0711 4.88934 19.0711 5.85897V7.55312C19.0711 7.8993 18.7908 8.18073 18.445 8.18255C18.4421 8.14079 18.4411 8.0835 18.4429 8.00386C18.4437 7.96804 18.4453 7.92397 18.447 7.87523C18.4504 7.77692 18.4546 7.65966 18.4546 7.55312V5.21663ZM11.7354 8.17667C11.7354 8.17668 11.7351 8.17678 11.7344 8.17695L11.7354 8.17667ZM18.3714 8.17667C18.3714 8.17666 18.3717 8.17675 18.3723 8.17696L18.3714 8.17667Z",
    stroke: "current",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0532 19.3475C15.4063 19.3475 15.757 19.2844 16.0239 19.1828L28.1064 15.1589V23.0829C28.1064 24.5235 26.9411 25.6889 25.5005 25.6889H4.60595C3.16535 25.6889 2 24.5235 2 23.0829V15.1588L14.0171 19.161C14.3399 19.2808 14.6897 19.3475 15.0532 19.3475Z",
    stroke: "current",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1662 16.6337L15.1574 16.6366L15.1487 16.6399C15.1289 16.6473 15.1013 16.6532 15.0532 16.6532C15.0052 16.6532 14.9775 16.6473 14.9577 16.6399L14.949 16.6366L14.9403 16.6337L2 12.3203V10.0942C2 8.65363 3.16535 7.48828 4.60595 7.48828H25.5005C26.9411 7.48828 28.1064 8.65363 28.1064 10.0942V12.3203L15.1662 16.6337Z",
    stroke: "current",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFinance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/finance.4c85db57.svg";
export { ForwardRef as ReactComponent };